import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        // 'yMax': "reset"
        field: "reset"
    },
    methods: {
        reset () {
            if(this._chart) this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        },
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const project = this._chart.config.data.datasets[chart_element._datasetIndex].project
                this.$emit("click", project.id, event)
            } catch (e) {}
        }
    },
    computed: {
        options () {
            return {
                onClick: this.click,
                tooltips: {
                    mode: "index",
                    position: "nearest",
                    yAlign: "center",
                    filter: tooltipItem => tooltipItem.value > 0,
                    callbacks: {
                        title: (tooltipItems, data) => {
                            let total = 0
                            data.datasets.forEach((dataset) => {
                                total += dataset.data[tooltipItems[0].index]
                            })
                            if(this.field === "fee") return `${tooltipItems[0].xLabel}: $ ${numeral(total).format("0,0")}`
                            return `${tooltipItems[0].xLabel}: ${numeral(total).format("0,0")} project(s)`
                        },
                        label: (tooltipItem, data) => {
                            if(this.field === "fee") return `${data.datasets[tooltipItem.datasetIndex].label}: $ ${numeral(tooltipItem.value).format("0,0")}`
                            return data.datasets[tooltipItem.datasetIndex].label
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        stack: "main",
                        ticks: {
                            beginAtZero: true,
                            // suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: (value, index, values) => {
                                const value_numeral = numeral(value)
                                values = value_numeral.value()
                                if(this.field === "fee") {
                                    if(value >= 1000000) return `$ ${numeral(value / 1000000).format("0,0.0")}M`
                                    if(value >= 1000) return `$ ${numeral(value / 1000).format("0,0")}K`
                                    return `$ ${value_numeral.format("0,0")}`
                                }
                                return `${value_numeral.format("0,0")}`
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        stack: "main",
                        scaleLabel: {
                            display: true,
                            labelString: "Date when project was turned active",
                            fontSize: 10
                        },
                        ticks: {
                            fontSize: 10,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: false,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        field: {
            type: String,
            required: true
        }/*,
        yMax: {
            type: Number,
            default: 0
        } */
    }
})
